<template>
  <tr>
    <td>
      {{ item.agencia }}
    </td>
    <td>
      {{ item.file }}
    </td>
    <td>
      {{ item.nombre }}
    </td>
    <td class="text-center">
      {{ item.nroAdultos }}
    </td>
    <td class="text-center">
      {{ item.nroNinos }}
    </td>
    <td>
      {{ item.hotel }}
    </td>
    <td class="text-center">
      {{ item.servicioTipo }}
    </td>
    <td class="text-center">
      <template v-if="estaLiquidado">{{ item.moneda }}</template>
      <InputSelect
        v-else
        v-model="item.tempMoneda"
        :inputClass="'form-control-table text-center'"
        :options="monedas"
        :reduce="(opt) => opt.sigla"
        label="sigla"
        rules="required"
        :errorMode="'tooltip'"
        name="Moneda"
        :vid="`moneda_${item.id}`"
      ></InputSelect>
    </td>
    <td class="text-center">
      <template v-if="estaLiquidado">{{ item.tarifa | number(2) }}</template>
      <InputText
        v-else
        v-model="item.tarifa"
        :vid="`tarifa_${item.id}`"
        name="Tarifa"
        rules="required|number"
        :errorMode="'tooltip'"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
    <td>
      <template v-if="estaLiquidado">{{ item.observaciones }}</template>
      <InputTextArea
        v-else
        v-model="item.observaciones"
        :vid="`observaciones_${item.id}`"
        :name="'Observaciones'"
        :errorMode="'tooltip'"
        inputClass="form-control form-control-table"
      ></InputTextArea>
    </td>
  </tr>
</template>

<script>
import InputSelect from "../../shared/components/InputSelect.vue";
import InputText from "../../shared/components/InputText.vue";
import InputTextArea from "../../shared/components/InputTextArea.vue";

import { mapGetters } from "vuex";
export default {
  components: { InputTextArea, InputText, InputSelect },
  props: {
    item: Object,
  },

  computed: {
    ...mapGetters("ordenDeServicio.liquidar", ["estaLiquidado", "monedas"]),
  },
  methods: {
    // onRemove() {
    //   this.$store.dispatch("ordenDeServicio.liquidar/remove", this.item.id);
    // },
  },
};
</script>

<style></style>
